import type { HttpErrorResponse } from '@angular/common/http';

import type {
  LanguageConfigType,
  LanguageSettings,
  SetAsDefaultErrorData,
} from '@core/languages-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<LanguageConfigType>()(
  EntityStoreKey.languageConfig,
  {
    customActions: adapter => ({
      toggleMultilangEnable: (state, payload: Partial<LanguageSettings>) =>
        adapter.markAsPending(state),
      toggleMultilangEnableSuccess: (state, payload: LanguageConfigType) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      toggleMultilangEnableFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),

      makeLanguageAsDefault: (state, payload: Partial<LanguageSettings>) =>
        adapter.markAsPending(state),
      makeLanguageAsDefaultSuccess: (state, payload: LanguageConfigType) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      makeLanguageAsDefaultFailed: (
        state,
        payload: { error: HttpErrorResponse & { errors: SetAsDefaultErrorData[] } },
      ) => adapter.setError(state, payload),

      updateCompanyLanguage: (state, payload: Partial<LanguageSettings>) =>
        adapter.markAsPending(state),
      updateCompanyLanguageSuccess: (state, payload: LanguageConfigType) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateCompanyLanguageFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload.error),
    }),
  },
);

export {
  actions as LanguageConfigActions,
  reducer as LanguageConfigReducer,
  selectors as LanguageConfigSelectors,
  namespace as LanguageConfigNamespace,
};
